import { StorageKey, AppError } from 'models';
import { useState } from 'react';
import LocalStorage from '../services/localStorage';

interface StorageHookResponse {
  error: null | AppError;
  get: <T>(key: StorageKey) => Promise<T | null>;
  set: <T>(key: StorageKey, data: T) => Promise<void>;
  remove: <T>(key: StorageKey) => Promise<void>;
}

const useLocalStorage = (): StorageHookResponse => {
  const [error, setError] = useState(null as null | AppError);

  const get = async <T>(key: StorageKey): Promise<T | null> => {
    let response = null;
    const result = await LocalStorage.get<T>(key);
    switch (result.type) {
      case 'success':
        response = result.data;
        break;
      case 'error':
        setError(result.error);
        break;
      default:
    }
    return response;
  };

  const set = async <T>(key: StorageKey, data: T): Promise<void> => {
    await LocalStorage.set<T>(key, data);
  };

  const remove = async <T>(key: StorageKey): Promise<void> => {
    await LocalStorage.remove(key);
  };

  return { error, set, get, remove };
};

export default useLocalStorage;
